module.exports = __webpack_public_path__ + "static/media/line.a4e6ed62.svg";